import React from 'react'
import '../styles/Hireme.css'
const Hireme = () => {
  return (
    <div className='h-container'>
      <div className='h-box1'>
        <h1 className='a-head' style={{color:"white" }}>I'm Available<br/> for Freelanser Projects !</h1>
        {/* <p className='a-description'>I'm a skilled Junior Front-End Developer proficient in ReactJS, HTML, CSS, and Java, ready to bring your digital ideas to life.
</p> */}
      </div>
      <div className='h-box2'>
<a href='mailto:rajivthejutheju@gmail.com'> <button className='a-button'>Hire me </button></a>
    </div>
    </div>
  )
}

export default Hireme
